// Sends SPA page loads to Ahoy as $view events. Skip the dashboard itself.
import ahoy from "ahoy.js";

const csrf = document.querySelector("meta[name='csrf-token']");
ahoy.configure({
  useBeacon: false,
  withCredentials: true,
  headers: csrf ? { "X-CSRF-Token": csrf.getAttribute("content") } : {},
});

export default function trackPageView(options = {}) {
  const page = options.page || window.location.pathname;
  if (page === "/page_views" || _.startsWith(page, "/page_views/") || _.startsWith(page, "/page_views?") || _.startsWith(page, "/panel-left")) {
    return;
  }

  ahoy.trackView({
    url: window.location.href,
    page: page,
  });
}
